import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { featureKey, State } from 'app/virtual-event/features';
import { AcitivityEntity } from 'app/virtual-event/models/acitivity.model';

export const selectActivityState = createFeatureSelector<State>(
  featureKey
);

export const selectVirtualEventActivity = createSelector(
  selectActivityState,
  ({ activity }) => activity
);